import qs from 'qs';
import { isEmpty, keyBy, mapValues, isObject, pick } from 'lodash';
import retry from 'async-retry';
import fileDownload from 'js-file-download';
import numeral from 'numeral';
import Encoding from 'encoding-japanese';

import firebase from './firebase';
import env from './env';

const { entries } = Object;

export function fullPathWithParams(params, { pathname, search }, currentParamNames) {
  const currentParams = qs.parse(decodeURI(search.slice(1)));
  const newParams = {
    ...(currentParamNames ? pick(currentParams, currentParamNames) : currentParams),
    ...params,
  };
  const newSearch = qs.stringify(newParams);
  return `${pathname}${newSearch ? `?${newSearch}` : ''}`;
}

export function readFile(file, type = 'readAsText') {
  const reader = new FileReader();
  reader[type](file);
  return new Promise((resolve) => {
    reader.addEventListener('load', (_) => resolve(_.target.result));
  });
}

export const fetchPdf = (_html, options = null, _launchOptions = null) => {
  const url = `${env('CLOUD_FUNCTIONS_ENDPOINT')}/html2Pdf`;
  const html = (_html || document.documentElement.outerHTML)
    .replace(/<script.*?>.*?<\/script>/gi, '')
    .replace(/\/static/gi, `${env('HOSTING_HOST')}/static`);
  const pdfOptions = {
    margin: { top: 60, bottom: 60, },
    format: 'a4',
    ...options,
  };
  const launchOptions = {
    deviceScaleFactor: 10,
    ..._launchOptions,
  };
  const body = JSON.stringify({ html, pdfOptions, launchOptions, });
  const headers = { 'Content-Type': 'application/json' };
  return retry(() => {
    return fetch(url, { method: 'POST', body, headers })
      .then(_ => _.blob());
  }, { retries: 3 });
};

export async function downloadDocument (selector, title) {
  const pageNode = document.querySelector('html').cloneNode(true);
  pageNode.querySelector('body').innerHTML = document.querySelector(selector).innerHTML;
  const pdf = await fetchPdf(pageNode.outerHTML, { printBackground: true });
  fileDownload(pdf, `${title}.pdf`);
};

export function encode (text, encoding = 'SJIS') {
  console.log(1, encoding);
  const code = Encoding.stringToCode(text);
  return new Uint8Array(Encoding.convert(code, encoding, 'UNICODE'));
};
